var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"py-0"},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-file-input',{attrs:{"label":_vm.label,"accept":"image/*","prepend-icon":"mdi-camera-outline","truncate-length":"10","hide-details":"","outlined":""},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }